export default ({ result: { id } }) => {
  return [{ customerID: id }];
};
